<!---
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="referenzExcel">{{ command.Inputs.REFERENZ_EXCEL.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="command.Inputs.REFERENZ_EXCEL.hint">
      <input nz-input formControlName="referenzExcel" id="referenzExcel" [placeholder]="command.Inputs.REFERENZ_EXCEL.placeholder"/>
    </nz-form-control>
  </nz-form-item>
 -->
<nz-spin [nzSpinning]="$loading | async">
  <form nz-form [formGroup]="form" (ngSubmit)="submit()">
<!--- << custom    -->
    <nz-form-item style="width: 100%;">
      <nz-form-control [nzErrorTip]="command.Inputs.REFERENZ_EXCEL.hint">
        <pbc-file-upload style="width: 100%;" formControlName="referenzExcel" id="referenzExcel" (uploaded)="submit()"
                               [icon]="'file-excel'" [text]="command.Inputs.REFERENZ_EXCEL.title" [hint]="command.Inputs.REFERENZ_EXCEL.hint"></pbc-file-upload>
      </nz-form-control>
    </nz-form-item>
<!---    custom >> -->
<!---
<button nz-button nzType="primary"
  type="submit"
  [nzLoading]="$loading | async" [disabled]="!form.valid || ($loading | async)"
  nz-tooltip [nzTooltipTitle]="SubmitTooltip">
    {{ command.translation }}
  <ng-template #SubmitTooltip>
  </ng-template>
</button>
 -->
  </form>
</nz-spin>
